import { useEffect, useMemo, useRef, useState } from "react";
import Container from "../../components/menu/Container";
import { maskCpfCnpj } from "../../utils/documento";
import { useTranslation } from "react-i18next";
import { Panel } from "primereact/panel";
import { Dropdown } from "primereact/dropdown";
import { Messages } from "primereact/messages";
import { HeaderTitle } from "../../components/HeaderTitle";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import getMotorCredito from "../../service/getMotorCredito";
import postPropostaCreditoProcess from "../../service/postPropostaCreditoProcess";
import ResultadoPropostaCreditoPage from "./ResultadoPropostaCredito";
import getCacheProposta from "../../service/getCacheProposta";

export default function ConsultaPage() {
  const { t } = useTranslation();
  const initialized = useRef(false);
  const msgs = useRef<Messages>(null);
  const [resposta, setResposta] = useState<any | null>(null);
  const [documento, setDocumento] = useState<string>();
  const [motores, setMotores] = useState<any[]>();
  const dadosManual : any[] = [];

  const addDadosManual = (id:string , value:string ) => {
    dadosManual.push({id, value});
  }

  const handleDocumento = (event: any) => {
    event.target.value = maskCpfCnpj(event.target.value);
  };

  const handleProcessFilter = () => {
    
    postPropostaCreditoProcess({dadosManual:dadosManual, motor:selectedMotor, documento: documento?.replaceAll('.','').replaceAll('-','').replaceAll('/','')}).then((response) => setResposta(response))
    
  };
  const [selectedMotor, setSelectedMotor] = useState();
  
  const findCacheById = (id: string) => {
    if (id && !id.includes("proposta")) {
      getCacheProposta(id).then((data) => {
        window.scrollTo(0, 0);
        setResposta(data);
      });
    }
  }; 

  const formulasManual = useMemo(()=>{
    if(selectedMotor){
      return motores?.filter((s:any) => s.id === selectedMotor)[0]?.formulasDadosManual;
    }
    return [];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMotor])

  useEffect(() => {
    getMotorCredito().then((data) => setMotores(data));
    if (!initialized.current) {
      initialized.current = true;
      findCacheById(
        window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ]
      );
    }
  }, []);

  return (
    <Container>
      <HeaderTitle
        icon="pi-search-plus"
        title={t("propostaCredito")}
        subtitle="Consulte os dados do seu cliente utilizando nossas informações como base."
      />

      <div className="row">
        <div style={{paddingTop: '2rem'}} className="col-lg-6 mb-3">
          <Messages ref={msgs} />
          {resposta == null && (
            <Panel header='Proposta Crédito'>
              <label htmlFor="cpf" className="font-bold block mb-2 required">Motor Crédito</label>
              <Dropdown
                onChange={(e) => {setSelectedMotor(e.value);console.log(motores?.filter((s:any) => s.id === e.value)[0].formulasDadosManual)}}
                options={motores}
                value={selectedMotor}
                optionLabel="descricao"
                placeholder="Selecione o Motor"
                optionValue="id"
                className="w-full md:w-14rem"
              />
              <br></br>
              <br></br>
              <label htmlFor="cpf" className="font-bold block mb-2 required">Documento</label>
              <InputText
                  id="documento"
                  maxLength={18}
                  max={18}
                  onKeyUp={handleDocumento}
                  onBlur={(e) => setDocumento(e.target.value)}
                  style={{ width: "20rem" }}
                ></InputText>
                <br></br>
                {formulasManual.map((item:any) => (
                  <div key={'div_' + item.id}>
                    <br></br>
                    <label htmlFor={item.id} className="font-bold block mb-2">{item.descricao}</label>
                    <InputText
                        id={item.id}
                        onBlur={(e) => addDadosManual(item.id, e.target.value)}
                        style={{ width: "20rem" }}
                      ></InputText>
                      <br></br>
                  </div>
                ))}
                <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex ">
                  <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Analisar"  onClick={handleProcessFilter} />
                </div> 
            </Panel>
            
          )}
          
        </div>
      </div>
      {resposta != null && (
            <ResultadoPropostaCreditoPage resultado={resposta} onClose={() => {setResposta(null)}} ></ResultadoPropostaCreditoPage>
          )}
    </Container>
  );
}
